import IconBag from "../../../../../img/Bag.png";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { match, round } from "../../../../../Others/functions";
import { useTranslation } from "react-i18next";
const store = "Rashan-4";
const vendorId = "37cfbaa0cdd335e81abd4aba05c5e254";

const AddedToCartBtmSheet = ({ screenName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  const info = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.info
  );

  const cart = useSelector(
    (state) =>
      state.user.cart?.filter((c) => c.vendorId === vendorId)?.[0]?.cart
  );
  const [bill, setBill] = useState(null);

  useEffect(() => {
    if (cart?.length) {
      let temp = cart.reduce((t, product) => {
        let MRP = t.MRP || 0;
        let productDiscount = t?.["Product discount"] || 0;
        let slabDiscount = t?.["Slab discount"] || 0;
        let freeProduct = t?.["Free item discount"] || 0;
        let total = t.Total || 0;

        MRP += product.mrp * product.qty;
        productDiscount += (product.mrp - product.sp) * product.qty;
        slabDiscount += (product.sp - product.finalSp) * product.qty;
        freeProduct += product.free * product.mrp;
        total += product.finalSp * product.qty;

        t = {
          MRP: round(MRP, 2),
          "Product discount": round(productDiscount, 2),
          "Slab discount": round(slabDiscount, 2),
          "Free item discount": round(freeProduct, 2),
          Total: round(total, 2),
          "Coupon discount": 0,
        };
        return t;
      }, {});

      if (state && state?.coupon.billAmount <= temp.Total) {
        let coupon = state.coupon;
        let discount;
        if (coupon.discountType === "Flat Discount") {
          discount = coupon.amount;
        } else {
          discount = round((temp?.Total * coupon.percent) / 100, 2);
          if (
            coupon.maxDiscount &&
            parseFloat(discount) > parseFloat(coupon.maxDiscount)
          ) {
            discount = coupon.maxDiscount;
          }
        }
        temp.Total = round(temp.Total - discount, 2);
        temp["Coupon discount"] = discount;
      }

      let offer = false;

      if (
        info?.cartOfferFlag3 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue3)
      )
        offer = info.cartOffer3;
      else if (
        info?.cartOfferFlag2 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue2)
      )
        offer = info.cartOffer2;
      else if (
        info?.cartOfferFlag1 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue1)
      )
        offer = info?.cartOffer1;

      if (offer) {
        let discount = round((temp?.Total * offer) / 100, 2);
        temp["cart discount"] = {
          pcnt: offer,
          str: `${offer}% cart discount`,
          amt: discount,
        };
        temp["Grand Total"] = round(temp.Total - discount, 2);
      }

      temp.saved = Object.keys(temp).reduce(
        (sum, type) =>
          type.includes("discount")
            ? type === "cart discount"
              ? (sum += temp[type].amt)
              : (sum += temp[type])
            : sum,
        0
      );

      setBill(temp);
    }
  }, [cart, info, state]);

  {
    /* ---------------------JSX RETURN-------------------- */
  }
  return cart?.length ? (
    <div className="cart-bottom-sheet bg-white">
      <div className="d-flex align-items-center justify-content-between">
        <div className="card flex-row align-items-center card-bottom border-0">
          <img src={IconBag} className="bagicon" alt="IconBag" />
          <div className="card-body p-0">
            <h3>
              {cart.length} {t("item")}
            </h3>

            <div className="d-flex align-items-center">
              <h5>
                <strong>{`₹${bill?.Total}`}</strong>
                {bill?.MRP !== bill?.Total && <del>{`₹${bill?.MRP}`}</del>}
              </h5>
              {bill?.MRP !== bill?.Total && (
                <span className="badge badge-success">{`Save ₹${bill?.saved}`}</span>
              )}
            </div>
          </div>
        </div>
        {screenName ? (
          <button
            onClick={() =>
              navigate(`/${screenName}`, {
                replace: true,
              })
            }
            className="btn btn-orange morebtn"
          >
            {t("Add More")}
          </button>
        ) : (
          <button
            onClick={() => navigate(`/cart`)}
            className="btn btn-orange morebtn"
          >
            {t("View Cart")}
          </button>
        )}
      </div>
    </div>
  ) : null;
};

export default AddedToCartBtmSheet;
